module.exports = __webpack_public_path__ + "img/country-invited.5806f917.svg";